// Fills the Saved page from the handles <capra-save-button> keeps in
// localStorage (capra-product.js), newest first. Each card is the
// capra-saved-card section rendered on its product URL. A product that no
// longer exists (404) is dropped from the list; any other failure leaves it
// saved and skips the card this time.
if (!customElements.get('capra-saved-list')) {
  customElements.define(
    'capra-saved-list',
    class CapraSavedList extends HTMLElement {
      async connectedCallback() {
        const SaveButton = await customElements.whenDefined('capra-save-button');
        const handles = this.read(SaveButton.storageKey);

        const results = await Promise.all(handles.map((handle) => this.fetchCard(handle)));
        const gone = handles.filter((handle, index) => results[index] === 'gone');
        if (gone.length > 0) {
          this.write(SaveButton.storageKey, this.read(SaveButton.storageKey).filter((h) => !gone.includes(h)));
        }

        const grid = this.querySelector('ul');
        const cards = results.filter((card) => card instanceof Element);
        cards.reverse().forEach((card) => {
          const item = document.createElement('li');
          item.append(card);
          grid.append(item);
        });

        grid.hidden = cards.length === 0;
        this.querySelector('.capra-collection__empty').hidden = cards.length > 0;
        this.setAttribute('aria-busy', 'false');
      }

      async fetchCard(handle) {
        try {
          const url = `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}?section_id=${this.dataset.section}`;
          const response = await fetch(url);
          if (response.status === 404) return 'gone';
          if (!response.ok) return null;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          return html.querySelector('.capra-saved__item');
        } catch {
          return null;
        }
      }

      read(key) {
        try {
          const list = JSON.parse(window.localStorage.getItem(key));
          return Array.isArray(list) ? list : [];
        } catch {
          return [];
        }
      }

      write(key, list) {
        try {
          window.localStorage.setItem(key, JSON.stringify(list));
        } catch {
          // Storage disabled: the stale handle is tried again next visit.
        }
      }
    }
  );
}
